import { render } from "./renewPassword.vue?vue&type=template&id=d130e5f8&scoped=true"
import script from "./renewPassword.vue?vue&type=script&lang=js"
export * from "./renewPassword.vue?vue&type=script&lang=js"

import "./renewPassword.vue?vue&type=style&index=0&id=d130e5f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d130e5f8"]])

export default __exports__